import { uniq } from 'lodash';
import { useMemo } from 'react';

/**
 * Ottiene la lista dei campi dipendenti in modo assoluto.
 * Non mantiene ordinamenti o riferimenti ai campi, in quanto è utilizzato
 * solo per il refresh dei campi tramite `useWatch`.
 */
export function useAbsoluteDeps(allDeps: string[][], names: string[]) {
  return useMemo(() => {
    if (!allDeps || allDeps.every(d => d.length === 0)) return [];

    return uniq(
      allDeps.flatMap((deps, index) => {
        // Processiamo le dipendenze per ogni campo, quindi potenzialmente
        // i nomi dei campi sono diversi
        const name = names[index];

        const baseTokens = [...name.split('.')];
        baseTokens.pop(); // rimuove il nome del campo

        // Ricostruisce il nome della dipendenza assoluta, a partire dal nome
        // del campo corrente ("base") e dal percorso relativo della dipendenza
        // es. `^.nome` -> indica che la dipendenza è un campo "fratello" del
        // "padre" del campo corrente, quindi si risale di un livello e si
        // aggiunge il nome del campo dipendente.
        return deps.map((dep: string) => {
          const depTokens = [...baseTokens];
          dep.split('.').forEach(t => {
            if (t === '^') {
              depTokens.pop();
            } else {
              depTokens.push(t);
            }
          });
          return depTokens.join('.');
        });
      }),
    );
  }, [allDeps, names]);
}
